import { useEffect, useState } from "react";
import apiClient from "../lib/api";

const SPORT_ICON = { football: "⚽", nba: "🏀", mlb: "⚾" };

export default function ResultsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    apiClient.get("/picks/public/ticker")
      .then(r => { if (r.data.picks?.length > 0) setItems(r.data.picks); })
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  const display = items.length < 5 ? [...items, ...items, ...items] : [...items, ...items];

  return (
    <div
      data-testid="results-ticker"
      style={{
        background: "#070707",
        borderBottom: "1px solid rgba(212, 175, 55, 0.12)",
        height: "32px",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <style>{`
        @keyframes ticker-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .ticker-inner {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          animation: ticker-scroll 45s linear infinite;
          will-change: transform;
          height: 100%;
          max-width: none !important;
          width: max-content;
        }
        .ticker-inner:hover { animation-play-state: paused; }
      `}</style>
      <div className="ticker-inner">
        {display.map((pick, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-1.5 px-4 h-full text-xs font-semibold tracking-wide"
          >
            <span style={{ fontSize: "13px" }}>{SPORT_ICON[pick.sport] || "🏆"}</span>
            <span style={{ color: "#e4e4e7" }}>
              {pick.home_team} vs {pick.away_team}
            </span>
            <span
              style={{
                fontWeight: 900,
                color: pick.status === "won" ? "#00C853" : "#ef4444",
                fontSize: "13px",
              }}
            >
              {pick.status === "won" ? "✓" : "✗"}
            </span>
            {pick.odds && (
              <span style={{ color: "#D4AF37", fontWeight: 700, fontSize: "11px" }}>
                @{pick.odds?.toFixed(2)}
              </span>
            )}
            <span style={{ color: "#333", margin: "0 6px" }}>|</span>
          </span>
        ))}
      </div>
    </div>
  );
}
